import React from 'react'
import { Switch } from 'react-router-dom'
import WholesalerFormListPage from 'app-support/wholesaler_forms/views/WholesalerFormListPage'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_WHOLESALERS } from 'app-support/permissions/Permissions'
import { wholesaleFormRouteListPage } from 'routes/routeNames'

const ModulesRoutes: React.FC = () => {
  return (
    <Switch>
      <PermissionRoute
        permission={PERMISSION_MANAGE_WHOLESALERS}
        exact
        path={wholesaleFormRouteListPage}
        component={WholesalerFormListPage}
      />
    </Switch>
  )
}

export default withRegionSwitchHandler('/wholesale-forms')(ModulesRoutes)
